// Tracks page views & engagement on every route change.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";
import {
  trackPageView as unifiedPageView,
  initEngagementTracking,
  resetEngagementTracking,
} from "../../utils/unifiedTracking";

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    resetEngagementTracking();
    trackPageView(location.pathname); // legacy GA4 + MongoDB
    unifiedPageView(); // unified tracking
    initEngagementTracking();
  }, [location.pathname]);

  return null;
};

export default PageTracker;
